import React, {memo, useState} from 'react';

import './index.scss';
import {Container} from '../../components/Container';

export const IframeScreen = memo(function IntercomScreen() {
    const [iframeUrl, setIframeUrl] = useState('http://192.168.5.5:8083/');
    return (
        <Container>
            <div className="page-wrapper">
                <div className="iframe-parent">
                    <iframe src={iframeUrl}/>
                </div>
            </div>
        </Container>
    );
});
